import { useEffect } from 'react';

/** 往下捲超過這個距離才收起，避免輕微抖動就收起；往上捲超過 UP 就出現 */
const DOWN = 12;
const UP = 8;
/** 頁面頂端附近永遠顯示 */
const TOP_ZONE = 80;

/**
 * 手機頂部列：往下捲時收起、往上捲時出現。狀態寫在 <html data-bar-hidden>，
 * CSS 依此移動頂部列與固定的分組標題（只有手機寬度的樣式會使用它）。
 */
export function useHideOnScroll(enabled: boolean) {
  useEffect(() => {
    const root = document.documentElement;
    if (!enabled) {
      delete root.dataset.barHidden;
      return;
    }
    let last = window.scrollY;
    let frame = 0;
    const onScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const y = window.scrollY;
        const delta = y - last;
        if (y < TOP_ZONE || delta < -UP) {
          delete root.dataset.barHidden;
          last = y;
        } else if (delta > DOWN) {
          // 焦點在頂部列裡（正在輸入搜尋）時不收起
          if (!document.activeElement?.closest('.app-bar')) root.dataset.barHidden = '';
          last = y;
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      delete root.dataset.barHidden;
    };
  }, [enabled]);
}
